<template>
  <div class="c-filter-section c-package-page__section mb-">
    <input
      class="c-filter-section__checkbox u-visuallyhidden"
      :id="'filter-section__price-detail-'+ myId"
      type="checkbox"
      :checked="defaultOpen"
    >
    <label
      class="c-filter-section__header c-package-page__section-header pl portable--mh"
      :for="'filter-section__price-detail-' + myId"
    >
      <div class="layout">
        <h5 class="u-font-style--italic mb0 layout__item u-4/5">
          <slot name="header"></slot>
        </h5>
        <h5 class="u-weight--normal mb0 layout__item u-1/5 u-text-align--right palm-pl- pr">Details</h5>
      </div>
    </label>
    <div class="c-filter-section__body c-package-page__section-body">
      <div class="layout">
        <div class="layout__item u-1/1 zeta ph- mh-">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		defaultOpen: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		return {
			myId: parseInt(Math.random() * 561561651)
		};
	}
};
</script>

<style>
</style>
